<template>
  <div class="showlogo">
<!--    <div class="logo" v-if="!isCollapse">{{ title }}</div>-->
<!--    <div class="logom" v-else>{{ title }}</div>-->
    <div class="logom">
      <img :src="defaultImg" style="height: 45px"/>
      <span v-if="sidebar.opened" style="color: #5111ee;font-weight: bold;font-size: 22px">万德付平台</span>
      <!-- <span v-if="sidebar.opened" style="color:#000;font-weight: bold;font-size: 22px">睿收钱</span> -->
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          :background-color="variables.menuBg"
          :text-color="variables.menuText"
          :active-text-color="variables.menuActiveText"
          :collapse="isCollapse"
          unique-opened
          router
          @open="handleopen"
          @close="handleclose"
          @select="handleselect"
      >
      <!-- <template v-for="(item,index) in routeslists">
          {{item.meta.title}}
      </template> -->
        <template v-for="(item,index) in routeslists">
          <template v-if="item.children.length >= 1 && (!item.hasOwnProperty('roles') || item.roles.includes(role))">
            <el-submenu :key="index" :index="index+''" class="submenu">
              <template slot="title">
                <i :class="item.icon"></i>
                <span slot="title">{{ item.meta.title }}</span>
              </template>
              <template v-for="child in item.children">
                <template v-if="!child.hasOwnProperty('roles') || child.roles.includes(role)">
                  <el-menu-item
                      :index="child.path"
                      :key="child.path"
                  >{{ child.meta.title }}
                  </el-menu-item>
                </template>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <template v-if="!item.hasOwnProperty('roles') || item.roles.includes(role)">
              <el-menu-item :key="index" :index="item.children[0].path">
                <i :class="item.icon"></i>
                <span v-if="!isCollapse ">{{ item.meta.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import variables from "@/assets/styles/variables.scss";
import {mapGetters} from "vuex";
import deImg  from '@/assets/images/bg6.jpg';
import internal from "assert";
export default {
  name: "index",
  data() {
    return {
      title: '',
      routeslists:[], //菜单栏 
      role: 0,//角色编号
      defaultImg:deImg,
    };
  },
  created() {
     //设置当前权限
     let role = sessionStorage.getItem('role_id');
     this.role = parseInt(role);
  },
  mounted() {
    //获取目录 
    this.GetMenusList();
    this.title = sessionStorage.getItem('title'); //机构名称
  },
  computed: {
    ...mapGetters(["sidebar"]),
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  methods: {
    handleopen() {
      //console.log('handleopen');
    },
    handleclose() {
      //console.log('handleclose');
    },
    handleselect() {
    },
    //从接口获取目录 
    GetMenusList(){
      this.$api.post("/api/menu/getMenus", [], res => {
        this.routeslists = res.data.farmat_menu;
        if(res.data.farmat_menu){
          sessionStorage.setItem('routeslists',JSON.stringify(res.data.farmat_menu));
          sessionStorage.setItem('menu_path_all',JSON.stringify(res.data.menu_path_all));
        }
      

			})
    }
  },
};

</script>

<style scoped lang="scss">
/*隐藏文字*/
.el-menu--collapse .el-submenu__title span {
  display: none;
}

/*隐藏 > */
.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}

.logo {
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #eee;
  background-color: #ffffff;
}

.logom {
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: #eee;
  text-align: center;
  background-color: #ffffff;
}

::v-deep .el-submenu__title {
  font-size: 13px;
}

.el-menu-item {
  font-size: 13px;
}
.showlogo .el-menu-item.is-active{
  background-color: #5111ee !important;
}
.submenu .el-menu-item{
  background-color: #f2f2f2 !important;
}
.submenu .el-menu-item:hover{
  background-color: #cccccc !important;
}
</style>
